/**
 * @generated SignedSource<<a841d23d13d4753ceb73e02f0fcf3f0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "uuid"
      }
    ],
    "concreteType": "PortfolioUserMember",
    "kind": "LinkedField",
    "name": "portfolioAddUserByEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioAddUserByEmailMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PortfolioAddUserByEmailMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a881af4c276eaddfccb21ee66a170650",
    "id": null,
    "metadata": {},
    "name": "PortfolioAddUserByEmailMutation",
    "operationKind": "mutation",
    "text": "mutation PortfolioAddUserByEmailMutation(\n  $uuid: ID!\n  $input: PortfolioAddUserByEmailInput!\n) {\n  portfolioAddUserByEmail(uuid: $uuid, input: $input) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "fc2dab2e6526a6a6d53f5f061f3fc10f";

export default node;
